interface LeadData {
  name: string;
  email: string;
  phone: string;
  source: string;
}

const postLead = async (data: LeadData, context: string): Promise<void> => {
  try {
    const { name, email, phone, source } = data;

    const payload = {
      name,
      email,
      phone,
      source,
      interest: 'parceiro',
    };

    const response = await fetch(`${process.env.REACT_APP_API_URL}/leads`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      console.warn(`Erro ao salvar lead (${context}):`, response.statusText);
    }
  } catch (error) {
    console.warn(`Erro ao salvar lead (${context}):`, error);
  }
};

export const saveLeadFromCadastro = (data: LeadData): Promise<void> =>
  postLead(data, 'cadastro-parceiro');
